// extracted by mini-css-extract-plugin
export var statItem = "_mh-1";
export var statsRow = "_mh-0";